<template>
  <div class="about2">
    <!--顶部介绍-->
    <picture>
      <source media="(min-width: 768px)" srcset="@/assets/img/pc/about/about2/bakTop.png">
      <source media="(min-width: 320px)" srcset="@/assets/img/mobile/about/about2/bakTop.png">
      <img class="bakTop" src="@/assets/img/pc/about/about2/bakTop.png">
    </picture>
    <guide :guide="correspondGuide" :color="'rgb(90, 137, 227)'" style="position: relative;top: 2rem;"></guide>
    <!--主体内容-->
    <div class="x-container">
      <!--搜索框-->
      <section class="searchBox" v-show="true">
        <el-form class="form" :model="form" :label-position='labelPosition' :inline="true">
          <el-form-item  class="search" style="width: 100%;margin-bottom: 0;" :inline="true">
            <el-input v-model="form.search" placeholder="搜索" prefix-icon="el-icon-search" @input="searchData" class="material-detail-search-icon"></el-input>
          </el-form-item>
        </el-form>
      </section>

      <section class="services" >
        <p>{{fileTypeName}}</p>
        <div class="flexContainer">
          <div class="flexBox" :key="'flexBox'+index" v-for="(item,index) in currentMaterial" >
            <div class="inlineBlock" @click.prevent="downLoad(item.label)">
              <img src="@/assets/img/pc/serve/serve2/download.png" alt="">
              <span>{{item.label}}</span>
              <!--<span @click="downLoad(item.link)">{{item.label}}</span>-->
            </div>
          </div>
        </div>
        <el-pagination
          v-if="materialList.length>pageSize"
          class="pagination"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="materialList.length">
        </el-pagination>
      </section>

    </div>
  </div>
</template>

<script>
  import guide from '@/components/guide'
  import {getPublishedFileList,searchPubFiles} from '@/api/download'
  import {exportMethod} from '@/utils/fileExports'
  import qs from 'qs'
  import {mapActions, mapGetters} from "vuex";
  export default {
    name: "downloadDetail",
    components: {
      guide,
    },
    computed:{
      correspondGuide(){
        this.guide[3].label = this.labelMap[this.fileType];
        return this.guide;
      },
      fileTypeName(){
        return this.labelMap[this.fileType];
      },
      currentMaterial(){
        return this.materialList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
      },
      ...mapGetters(['getUserName'])
    },
    data() {
      return {
        guide: [
          // {label: '格力智能楼宇'},
          {label: '服务与支持'},
          {label: '资料下载'},
          {label: '资料下载'},
        ],
        labelMap:{
          1:"服务指导",
          2:"产品资料",
          3:'解决方案'
        },
        labelPosition: "left",
        keyMap:{
          1:"service",
          2:"product",
          3:'solution'
        },
        fileType:1,
        materialList:[],
        currentPage:1,
        pageSize:20,
        form:{
          search:''
        }
      }
    },
    methods: {
      ...mapActions(['openLoginDailog']),
      handleCurrentChange(val){
        this.currentPage = val;
      },
      downLoad(fileName){
        if (this.getUserName) {  // 已登录才可以下载
          let obj = {
            url:'api/file/downloadFile',
            method:'get',
            params: qs.stringify({
              fileName:fileName
            })
          }
          exportMethod(obj);
        } else {  // 未登录则弹出登录框
          this.openLoginDailog();
        }
      },

      /**
       * @Description: 获取列表
       * @author Li Yanjie
       * @date 2020/7/18
       * @param fileType {Number} 文件类型：1-服务指导，2-产品资料，3-解决方案
       * @return
      */
      getPublishedFileList(fileType){
        getPublishedFileList(fileType).then(res=>{
          if(res.returnCode==="100"){
            let arr = [];
            res.returnData.map(item=>{
              arr.push({
                label:item.fileName,
              })
            });
            this.materialList = arr;
          }else{
            this.materialList = []
          }
        }).catch(e=>e)
      },



      searchData(){
        this.currentPage = 1;
        searchPubFiles(this.fileType,this.form.search).then(res=>{
          if(res.returnCode==="100"){
            let arr = [];
            res.returnData.map(item=>{
              arr.push({
                label:item.fileName,
              })
            });
            this.materialList = arr;
          }else{
            this.materialList = []
          }
        }).catch(e=>e)
      }
    },
    mounted() {

    },
    beforeRouteEnter(to, from, next){
      next(vm=>{
        // vm.getNewsById(to.params.fileType);
        vm.fileType = to.params.fileType;
        vm.getPublishedFileList(to.params.fileType);
      })
    },
    beforeRouteUpdate (to, from, next) {
      // just use `this`
      this.fileType = to.params.fileType;
      this.getPublishedFileList(to.params.fileType);
      next()
    }
  }
</script>

<style scoped lang="less">
  .x-container {
    section {
      width: 80%;
      margin: auto;
      margin-bottom: 2rem;
    }
  }

  /*搜索框*/
  .form {
    text-align: center;
    width: 100%;
    box-sizing: border-box;
  }

  /*服务指导*/
  .services {
    background: #fff;
    min-height: 15rem;
    padding-bottom: 2rem;
    border-radius: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    box-sizing: border-box;
    p {
      color: @deepblue;
      text-align: center;
      padding: 1rem;
      border-bottom: 1px solid rgba(170, 164, 164, 0.29);
    }
    .flexContainer {
      display: flex;
      flex-wrap: wrap;
      padding: 1rem;
      .flexBox {
        margin-bottom: 1rem;
        text-align: left;
        display: block;
        width: 50%;
        cursor: pointer;
        img {
          margin-right: 10px;
        }
        span{
          font-size: 0.8rem;
        }
      }
    }
    @media only screen and (min-width: 320px) {

      .flexContainer .flexBox {
        width: 100%;
      }
    }
    @media only screen and (min-width: 768px) {
      .flexContainer .flexBox {
        width: 50%;
      }

    }
  }

  /*头部背景图*/
  .bakTop {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
  }

</style>
<style lang="less" scoped>
  .x-container {
    /*搜索框*/
    .searchBox {
      .el-form--inline .el-form-item__label {
        color: @deepblue;
        font-size: 1rem;
      }
      .el-input__inner {
        border: 1px solid @blue;
        border-radius: 0;
      }
      /*搜索框*/
      .search {
        .el-form-item__content {
          width: 100%;
          .el-select {
            width: 100%;
          }
        }
      }
      .el-textarea__inner {
        min-height: 10rem !important;
        border: 1px solid @blue;
        border-radius: 0;
      }
    }
  }
  .material-detail-search-icon .el-input__icon.el-icon-search{
    color: @blue;
  }

  .inlineBlock {
    display: inline-block;
  }
</style>

